import { noop } from 'lodash'
import { createStore } from 'zustand'

import { flattenArrayTree } from '@eastcoal/common/utils/array'
import { Tree } from '@eastcoal/common/utils/tree'

import { menuTreeEqualityFn } from '../utils/equalityFn'

import { ResourceBaseTreeOptions, ResourceBaseTreeStore } from './interface'

const getExpandedKeys = (
  data: ResourceBaseTreeStore['data'],
  expandAll?: boolean
) => {
  return expandAll ? flattenArrayTree(data).map(item => item.key) : []
}

export const createResourceBaseTreeStore = ({
  data,
  defaultExpandAll
}: ResourceBaseTreeOptions) =>
  createStore<ResourceBaseTreeStore>((set, get) => ({
    data,
    expandedKeys: getExpandedKeys(data, defaultExpandAll),
    isExpanded() {
      return get().expandedKeys.length > 0
    },
    toggleExpandAll(expandAll) {
      const mergedExpandAll = expandAll ?? !get().isExpanded()
      set({
        expandedKeys: getExpandedKeys(get().data, mergedExpandAll)
      })
    },
    setExpendedKeys(expandedKeys) {
      set({ expandedKeys: expandedKeys as string[] })
    },
    reload: noop,
    tree: new Tree({
      equalityFn: menuTreeEqualityFn,
      getData: () => get().data,
      setData: data => set({ data })
    })
  }))
